export const ROOT_PATH = 'companies';

export enum CompanyProfilesPage {
  Home = ROOT_PATH,
  About = ':companySlug',
  Culture = 'culture',
  Jobs = 'jobs',
  Salaries = 'salaries',
  SalariesRole = 'salaries/:roleId',
  Reviews = 'reviews',
  ReviewsLocation = 'reviews/locations/:locationSlug',
  CompanySearch = 'search',
  WriteAReview = 'write-a-review',
}
